import {eTipoPermissao} from '@/enums/ePermissoes';
export default [
 {
  description: 'Utilização de Sala',
  path: '/gestao/utilizacaosala',
  name: 'utilizacaosala',
  component: () => import('@/views/gestao/utilizacaosala/Index.vue'),
  meta: {
   permissions: [eTipoPermissao.UTILIZACAODASALANOVO_MENU_300900194],
  },
  goesToMenu: true,
 },
 {
  description: 'Cadastro de Utilização de Sala',
  path: '/gestao/utilizacaosala/cadastro/:id?',
  parent: 'utilizacaosala',
  name: 'utilizacaosala_create',
  component: () => import('@/views/gestao/utilizacaosala/InclusaoEdicao.vue'),
  meta: {
   permissions: [eTipoPermissao.UTILIZACAODASALANOVO_MENU_300900194],
  },
  goesToMenu: true,
 },
]
